import loopPortrait from '../video/hero-loop-portrait.mp4'
import loopLandscape from '../video/hero-loop-landscape.mp4'
import { enableShareButtons } from './modules/helpers';

document.addEventListener('DOMContentLoaded', function() {
  
  enableShareButtons('.share-link');

  const heroLoop = document.querySelector('#heroLoop > source');

  const video = document.getElementById('heroLoop');

  const mq = window.matchMedia('(orientation: portrait)');

  function handleOrientationChange(e) {
    if (e.matches) {
      heroLoop.src = loopPortrait;
    } else {
      heroLoop.src = loopLandscape;
    }
  }

  mq.addListener(handleOrientationChange);

  handleOrientationChange(mq);

});
